import React,{useEffect} from "react";
import { Helmet } from "react-helmet";
import Global from "../../global";


const Head = (props) =>
{

    useEffect(() => {

        localStorage.setItem('page_title',props.title);
        localStorage.setItem('page_image',props.image);
        localStorage.setItem('page_description',props.description);


    },[props.title,props.image,props.description])


    return(<Helmet>
        {props.rtl?<html dir={"rtl"} lang={ Global.DEFAULT_LAN}></html>:""}
 <title>{props.title +" | "+Global.TITLE}</title>

     <meta charset="utf-8" />
     <meta http-equiv="X-UA-Compatible" content="IE=edge" />
     <meta name="csrf_token" content="" />
     <meta property="type" content="website" />
     <meta property="url" content={window.location.href} />
     <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"/>
     <meta name="theme-color" content="#000000" />
     <meta name="msapplication-TileColor" content="#ffffff" />
     <meta name="msapplication-TileImage" content={props.icon} />
     <meta name="theme-color" content="#ffffff" />
     <meta name="_token" content="" />
     <meta name="robots" content="noodp" />
     <meta property="title" content={props.title} />
     <meta property="quote" content={props.quote} />
     <meta name="description" content={props.description} />
     <meta property="image" content={props.image} />
     <meta property="og:locale" content="en_US" />
     <meta property="og:type" content="website" />
     <meta property="og:title" content={props.title} />
     <meta property="og:quote" content={props.quote} />
     <meta property="og:hashtag" content="#smott" />
     <meta property="og:image" content={props.image} />
     <meta content="image/*" property="og:image:type" />
     <meta property="og:url" content={window.location.href} />
     <meta property="og:site_name" content="SMOTT PREVIEW APP" />
     <meta property="og:description" content={props.description} /> 
     <link rel="icon" href={props.icon} sizes="32x32"></link>
     <link rel="icon" href={props.icon} sizes="192x192"></link>
     <link rel="apple-touch-icon" href={props.icon}/>            
    </Helmet>)
}

export default Head